'use client';

import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';

import SectionHeading from '@/app/components/SectionHeading';
import useScrollTracking from '@/app/hooks/useScrollTracking';

import PerimenopauseAccordion from './_components/PerimenopauseAccordion';
import PerimenopauseArticles from './_components/PerimenopauseArticles';
import PerimenopauseCards from './_components/PerimenopauseCards';
import PerimenopauseHero from './_components/PerimenopauseHero';
import PerimenopauseLearn from './_components/PerimenopauseLearn';

const Content = () => {
  // scroll depth tracking hook for segment analytics
  useScrollTracking();

  return (
    <div data-cy="perimenopause-page">
      <PerimenopauseHero />
      <LayoutGrid>
        <GridItem colStart={{ sm: 'main' }} colEnd={{ sm: 'main' }}>
          <SectionHeading
            className="py-10 max-lg:mb-10"
            content="perimenopause_50plus_metrics"
            animated
            typographyProps={{
              font: 'serif',
              variant: 'h1',
              className: 'text-center',
            }}
          />
        </GridItem>
      </LayoutGrid>
      <PerimenopauseCards />
      <PerimenopauseLearn />
      <LayoutGrid>
        <GridItem colStart={{ sm: 'main' }} colEnd={{ sm: 'main' }}>
          <SectionHeading
            className="pt-20 lg:pb-10"
            content="perimenopause_tune"
            animated
            typographyProps={{
              font: 'serif',
              variant: 'h1',
              className: 'text-center text-balance leading-tighter',
            }}
          />
        </GridItem>
      </LayoutGrid>
      <PerimenopauseAccordion />
      <PerimenopauseArticles />
    </div>
  );
};

export default Content;
